import { LoaderSmall } from "../../../components/Loaders"

export default function AssessmentListTableCreator({
  rowData,
  isLoadingUsers,
  users,
}) {

  //Handle system types created by the service user as Created by System
  if(rowData?.createdBy === "-12"){
    return <>System</>
  }

  const user = users?.filter(
    (user) =>
      user.staff_id === rowData.createdBy &&
      user.organizationId === rowData.organization_id
  )

  if (user?.length > 0) {
    return <>{user[0].staff_full_name}</>
  } else if (isLoadingUsers) {
    return <LoaderSmall />
  } else {
    return <>Unknown user</>
  }
}
